// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"60349074","977":"4b9883fe"}[chunkId] + ".chunk.js";
};